<template>
  <!-- 个人 -->
  <div class="box">
    <el-row type="flex">
      <el-col :span="10">
        <!-- 头像 -->
        <div class="head">
          <el-avatar :size="100">
            <img v-if="src !== ''" :src="src" alt="">
            <img v-if="src === ''" src="@/img/29.png" alt="">
          </el-avatar>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="text">
          <div>姓名：{{getName()}}</div>
          <div>岗位：{{post}}</div>
          <div>学时：{{get_learn}}</div>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between">
        <div class="kapian">
          <div class="el-icon-s-claim user"> 身份证号：</div><span class="user_value">{{id_number}}</span>
        </div>
    </el-row>
    <el-row type="flex" justify="space-between">
        <div class="kapian">
          <div class="el-icon-s-order user"> 手机号：</div><div class="user_value">{{phone}}</div>
        </div>
    </el-row>
    <el-row type="flex" justify="space-between">
        <div class="kapian">
          <div class="el-icon-s-check user"> 是否在船：</div><div class="user_value">{{is_onShip}}</div>
        </div>
    </el-row>
    <el-row type="flex" justify="space-between">
        <div class="kapian">
          <div class="el-icon-s-tools user"> 服务船只：</div><div class="user_value">{{ship_name}}</div>
        </div>
    </el-row>
    <el-row type="flex" justify="space-between">
        <div class="kapian">
          <div class="el-icon-s-tools user"> 年龄：</div><div class="user_value">{{age}}</div>
        </div>
    </el-row>
    <el-row type="flex" justify="space-between">
        <div class="kapian">
          <div class="el-icon-s-tools user"> 性别：</div><div class="user_value">{{sex}}</div>
        </div>
    </el-row>
     <div class="hr"></div>
     <div style="display:flex">
        <div @click="edit" class="button">
          编辑资料
        </div>
        <!-- <div @click="back" class="button">
          退出登录
        </div> -->
        <div @click="exportTimeList" class="button">
          学时证明
        </div>
     </div>
     <certificate></certificate>
  </div>
</template>

<script>
import * as req from '@/utils/request'
import certificate from '@/components/certificate.vue'
export default {
  data () {
    return {
      src: '',
      age: '',
      phone: '',
      // 身份证
      id_number: '',
      sex: '',
      // 是否在船
      is_onShip: '',
      // 服务船只
      ship_name: '',
      // 学习时长
      get_learn: '',
      // 用户信息
      user_info: '',
      // 姓名
      name: '',
      // 岗位
      post: '',
      // 学时
      time: '',
      // 基础未读
      basicsUnread: [],
      // 考核未读
      assessUnread: [],
      // 法规未读
      statutesUnread: [],
      study: {
        StudyPlan: '00',
        AssessmentItems: '00',
        LawLearning: '00'
      }
    }
  },
  components: {
    certificate
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    exportTimeList () {
      let id = this.gmdss.user_info.id
      let sendData = {}
      sendData.data = {
        id: id
      }
      sendData.fn = this.exportTimeListFn
      sendData.vm = this
      req.Post('certificate/get', sendData)
    },
    exportTimeListFn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      this.gmdss.exportList = data.data
      this.gmdss.dialogVisible = true
    },
    exportTime () {
      if (!this.gmdss.user_info) {
        return
      }
      let id = this.gmdss.user_info.id
      let sendData = {}
      sendData.data = {
        id: id
      }
      sendData.fn = this.exportTimeFn
      sendData.vm = this
      req.Post('online_duration/get_month', sendData)
    },
    exportTimeFn (data) {
      if (!data) {
        this.$message.error('您的学时为' + 0 + '学时,不符合导出条件')
        return
      }
      if (!data.total) {
        this.$message.error('您的学时为' + 0 + '学时,不符合导出条件')
        return
      }
      // 判断学时是否符合
      this.checkTime(data.total)
    },
    checkTime (total) {
      // 转化为小时
      let hour = total / 3600
      let stationId = this.gmdss.user_info.station_id
      let stationTime = 0
      // 如果station_id是1，2，3，4 学时标准为24小时 其余为20小时
      if (stationId === 1 || stationId === 2 || stationId === 3 || stationId === 4) {
        stationTime = 24
      } else {
        stationTime = 20
      }
      if (hour < stationTime) {
        this.$message.error('您的学时为' + hour.toFixed(2) + '学时,不符合导出条件,标准为' + stationTime + '学时')
        return
      }
      this.exportOnlineTimePng(stationTime)
    },
    // 辅助函数：文本自动换行
    wrapText (context, text, x, y, maxWidth, lineHeight) {
      const words = text.split('')
      let line = ''
      let currentY = y

      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n]
        const metrics = context.measureText(testLine)
        const testWidth = metrics.width

        if (testWidth > maxWidth && n > 0) {
          context.fillText(line, x, currentY)
          line = words[n]
          currentY += lineHeight
        } else {
          line = testLine
        }
      }
      context.fillText(line, x, currentY)
    },
    async exportOnlineTimePng (hour) {
      // 获取用户信息
      const userInfo = this.gmdss.user_info
      if (!userInfo) {
        this.$message.error('请先登录')
        return
      }

      // 获取当前日期
      const now = new Date()
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}年${month}月${day}日`
      }

      // 计算开始日期（假设培训周期为一个月）
      const startDate = new Date(now)
      startDate.setMonth(startDate.getMonth() - 1)

      // 创建canvas元素
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      // 设置画布尺寸
      canvas.width = 1080
      canvas.height = 764

      try {
        // 加载背景图片
        const backgroundImage = new Image()
        // 使用项目中的logo图片作为背景
        backgroundImage.src = require('@/assets/backBook.jpg')

        // 等待背景图片加载完成
        await new Promise((resolve, reject) => {
          backgroundImage.onload = () => resolve()
          backgroundImage.onerror = () => {
            // 如果背景图片加载失败，继续执行而不使用背景
            console.warn('背景图片加载失败，使用纯白背景')
            resolve()
          }
        })

        // 绘制背景图片，如果没有背景图片则保持白色背景
        if (backgroundImage.complete && backgroundImage.naturalWidth !== 0) {
          // 绘制背景图片，覆盖整个画布并设置透明度
          ctx.globalAlpha = 1 // 设置透明度为10%
          ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height)
          ctx.globalAlpha = 1.0 // 恢复透明度
        } else {
          // 如果没有背景图片，绘制白色背景
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
        }

        // 设置正文字体
        ctx.font = '20px SimSun, SimHei, Arial, sans-serif'
        ctx.fillStyle = '#000000' // 黑色
        ctx.textAlign = 'left'

        // 绘制学员姓名
        const userName = `${userInfo.name || '学员'}`
        ctx.fillText(userName, 120, 300)

        // 绘制培训详情
        const trainDetails = `  于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${hour}学时（60分钟/学时），符合要求。`
        this.wrapText(ctx, trainDetails, 120, 350, canvas.width - 240, 30) // 缩进20px

        // 绘制公司名称
        ctx.textAlign = 'right' // 右对齐
        const company = '福建省海运集团中平船舶管理有限公司'
        ctx.fillText(company, canvas.width - 120, 550)

        // 绘制日期
        const date = formatDate(now)
        ctx.fillText(date, canvas.width - 120, 600)

        // 转换为PNG并下载
        const pngUrl = canvas.toDataURL('image/png')

        // 创建下载链接
        const link = document.createElement('a')
        link.href = pngUrl
        link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.png`

        // 执行下载
        link.click()

        this.$message.success('PNG学时证明导出成功')
      } catch (error) {
        console.error('PNG导出失败:', error)

        // 如果背景图片加载失败，创建不带背景的图片
        this.createPlainPng(canvas, ctx, userInfo, hour, formatDate, startDate, now)
      }
    },

    // 不带背景的PNG创建函数
    createPlainPng (canvas, ctx, userInfo, hour, formatDate, startDate, now) {
      // 设置画布尺寸
      canvas.width = 800
      canvas.height = 1000

      // 设置背景色
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // 设置字体
      ctx.font = 'bold 36px SimSun, SimHei, Arial, sans-serif'
      ctx.fillStyle = '#000000'
      ctx.textAlign = 'center'

      // 绘制标题
      const title = '学时证明'
      ctx.fillText(title, canvas.width / 2, 80)

      // 设置正文字体
      ctx.font = '24px SimSun, SimHei, Arial, sans-serif'
      ctx.textAlign = 'left'

      // 绘制学员姓名
      const userName = `${userInfo.name || '学员'}：`
      ctx.fillText(userName, 80, 150)

      // 绘制培训详情（缩进两个字符）
      const trainDetails = `  于 ${formatDate(startDate)}——${formatDate(now)} 参加福建省海运集团中平船舶管理有限公司船员岗前线上培训课程，完成${hour}学时（60分钟/学时），符合要求。`
      this.wrapText(ctx, trainDetails, 100, 200, canvas.width - 160, 30) // 缩进20px

      // 绘制公司名称
      ctx.textAlign = 'right' // 右对齐
      const company = '福建省海运集团中平船舶管理有限公司'
      ctx.fillText(company, canvas.width - 80, 600)

      // 绘制日期
      const date = formatDate(now)
      ctx.fillText(date, canvas.width - 80, 650)

      // 转换为PNG并下载
      const pngUrl = canvas.toDataURL('image/png')

      // 创建下载链接
      const link = document.createElement('a')
      link.href = pngUrl
      link.download = `学时证明_${userInfo.name || '学员'}_${formatDate(now)}.png`

      // 执行下载
      link.click()

      this.$message.success('PNG学时证明导出成功（无背景）')
    },
    // 根据token获取用户信息
    deleteOpenid () {
      let sendData = {}
      sendData.data = this.gmdss.user_info.id_number
      sendData.fn = this.deleteOpenidfn
      sendData.vm = this
      req.Post('user/deleteOpenid', sendData)
    },
    deleteOpenidfn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    },
    // 返回
    back () {
      this.deleteOpenid()
      window.$gmdss.login = 'no'
      this.$router.push({path: './'})
    },
    edit () {
      let data = {}
      data.sex = this.sex
      data.is_onShip = this.is_onShip
      data.ship_name = this.ship_name
      data.user_info = this.user_info
      this.$router.push({path: '/edit', query: {user: data}})
    },
    getName () {
      if (!window.$gmdss.user_info) {
        return 'null'
      }
      this.learnTime()
      this.get_user_info()
      this.age = this.gmdss.user_info.age
      this.phone = this.gmdss.user_info.phone
      this.id_number = this.gmdss.user_info.id_number
      this.user_info = window.$gmdss.user_info
      if (window.$gmdss.user_info.user_img === null) {
        this.src = ''
      } else {
        this.src = window.$gmdss.src + window.$gmdss.user_info.user_img
      }
      let shipId = window.$gmdss.user_info.serve_ship
      let getShip = window.$gmdss.getShip
      if (window.$gmdss.user_info.is_onShip === false || window.$gmdss.user_info.is_onShip === '否') {
        this.is_onShip = '否'
      } else {
        this.is_onShip = '是'
      }
      if (!window.$gmdss.user_info.sex) {
        this.sex = '女'
      } else {
        this.sex = '男'
      }
      for (let i in getShip) {
        if (shipId === getShip[i].id) {
          this.ship_name = getShip[i].ship_name
          break
        }
      }
      return window.$gmdss.user_info.name
    },
    // 学习时间
    learnTime () {
      let time = this.gmdss.user_info.learn_time
      this.formateSeconds(time)
    },
    // 获取用户数据
    get_user_info () {
      let sendData = {}
      sendData.data = window.$gmdss.user_info.station_id
      sendData.fn = this.get_user_infoFn
      sendData.vm = this
      req.Post('user/get_station', sendData)
    },
    get_user_infoFn (data) {
      // console.log(data)
      // if (this.gmdss.station === '') {
      this.post = data.list[0].station
      // } else {
      // this.post = this.gmdss.station
      // }
    },
    // 将秒转化为时分
    formateSeconds (endTime) {
      if (endTime === null) {
        return '0 分'
      }
      let secondTime = parseInt(endTime) // 将传入的秒的值转化为Number
      let min = 0 // 初始化分
      let h = 0 // 初始化小时
      let result = ''
      if (secondTime > 59) { // 如果秒数大于59，将秒数转换成整数
        min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
        if (min > 60) { // 如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, '0')} 小时 ${min.toString().padStart(2, '0')}分`
      this.get_learn = result
      return result
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getName()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<style scoped>
.box{
  margin-bottom: 6rem;
}
.head{
  /* border: solid 1px aqua; */
  text-align: center;
  padding: 1rem;
}
.head img{
  width: 100%;
}
.text{
  flex-direction: column-reverse;
  padding-left: 2rem;
  font-size: 20px;
  font-weight: 550;
}
.text div{
  margin-top: 1rem;
}
.color{
  color: rgb(8, 150, 245);
}
.kapian{
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-top: solid 1px rgb(182, 182, 182);
}
.title{
  font-size: 14px;
}
.el-col{
  background-color: white;
}
.user_value{
  width: 50%;
  float: right;
  text-align: center;
}
.hr{
  width: 100%;
  border-top: solid 1px rgb(182, 182, 182);
}
.user{
  width: 40%;
  /* text-align: center; */
  margin-left: 1.5rem;
}
.button{
  margin:0 auto;
  margin-top: 2rem;
  width: 5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: rgb(64, 163, 255);
  text-align: center;
  color: #fff;
  border-radius: 7px;
  box-shadow: 2px 2px 1px rgb(45, 114, 178);
}
</style>



// WEBPACK FOOTER //
// src/components/custom.vue